'use client';

import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Box, Flex, Text } from '@eqi-investimentos/react';
import { Portal } from '@chakra-ui/react';
import { PATHS } from '@/config/paths';
import { OpenFinanceWidget } from '@/modules/Wallet/ui/Widgets/OpenFinance';
import { useInvest } from '@/contexts/InvestContext';
import { ExpansibleCard } from '@/components/molecules/ExpansibleCard';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { InvestmentsCategoriesCard } from './InvestmentsCategoriesCard';
import { InvestmentsSummaryCard } from './InvestmentsSummaryCard';
import { MyInstitutionsCard } from './MyInstitutionsCard';
const CONTAINER_WIDGET_ID = 'consolidator-widget';
export const MyInvestmentsWidget = () => {
  const {
    t
  } = useTranslation('common');
  const {
    openConnectorsDrawer
  } = useInvest();
  return <>
      <Portal data-sentry-element="Portal" data-sentry-source-file="index.tsx">
        <OpenFinanceWidget data-sentry-element="OpenFinanceWidget" data-sentry-source-file="index.tsx" />
      </Portal>
      <ExpansibleCard id={CONTAINER_WIDGET_ID} showMonetaryButton title={`${t('attributes.mines')} ${t('attributes.investments')}`} expandedHeight="35.875rem" data-sentry-element="ExpansibleCard" data-sentry-source-file="index.tsx">
        <Flex flexDir="column" gap="1.875rem" w="full" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <WidgetContainer containerId="my-investments-wallet" showTitles={false} sliderProps={{
          displayControls: false
        }} data-sentry-element="WidgetContainer" data-sentry-source-file="index.tsx">
            <InvestmentsSummaryCard data-sentry-element="InvestmentsSummaryCard" data-sentry-source-file="index.tsx" />
            <InvestmentsCategoriesCard openConnectorsDrawer={openConnectorsDrawer} t={t} data-sentry-element="InvestmentsCategoriesCard" data-sentry-source-file="index.tsx" />
            <Box w="25rem" h="26.25rem" data-sentry-element="Box" data-sentry-source-file="index.tsx">
              <MyInstitutionsCard openConnectorsDrawer={openConnectorsDrawer} t={t} data-sentry-element="MyInstitutionsCard" data-sentry-source-file="index.tsx" />
            </Box>
          </WidgetContainer>
          <Flex as={Link} href={PATHS.consolidator.index} alignItems="center" alignSelf="flex-end" gap="2" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Text fontSize="sm" lineHeight="5" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">{`${t('attributes.mine')} ${t('attributes.wallet')}`}</Text>
            <ChevronRight width={24} height={24} color="content.brand" data-sentry-element="ChevronRight" data-sentry-source-file="index.tsx" />
          </Flex>
        </Flex>
      </ExpansibleCard>
    </>;
};